import styled from 'styled-components';
import breakpoints from 'base/constants/breakpoints';

interface MobileProps {
  isMobile?: boolean;
}

export const BannerContainer = styled.div<MobileProps>`
  display: flex;
  width: 100%;
  padding: 12px 16px;
  background: #0071cd;
  cursor: pointer;
  box-sizing: border-box;
  justify-content: center;
  position: sticky;
  top: 76px;
  z-index: 1001;
  min-height: fit-content;

  &:hover {
    background: #005693;
  }

  @media screen and ${breakpoints.maxWidth.sm} {
    padding: 12px 16px;
  }
`;

export const BannerContent = styled.div<MobileProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  max-width: 1280px;
`;

export const BannerIconContainer = styled.div`
  width: 19.152px;
  height: 16.98px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BannerText = styled.span`
  color: #fff;
  text-align: center;
  font-family: 'Noto Sans', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.12px;
  text-decoration: none;

  ${BannerContainer}:hover & {
    text-decoration: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
  }
`;
